import React from 'react';
import StudentDashboard from './StudentDashboard';

// Alias for StudentDashboard component
const Dashboard = () => {
  return <StudentDashboard />;
};

export default Dashboard;